import { useState } from "react";
import { getProductName } from "@/components/history/ProductUtils";

export const useProductSearch = (stockItems: any[] = []) => {
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedProductId, setSelectedProductId] = useState("");

  const filteredProducts = stockItems.filter(item => {
    const productName = getProductName(item);
    const searchTerm = searchQuery.trim().toLowerCase();
    
    // Only log when there's actually a search term
    if (searchTerm) {
      console.log(`Filtering product: ${productName} with search term: ${searchTerm}`);
    }
    
    return productName.toLowerCase().includes(searchTerm);
  });

  const selectedProduct = stockItems.find(item => item.id === selectedProductId);

  return {
    searchQuery,
    setSearchQuery,
    selectedProductId,
    setSelectedProductId,
    filteredProducts,
    selectedProduct
  };
};